export default __webpack_public_path__ + "static/media/customer-support.61f570e9.jpg";